import {
    FETCH_MESSAGES,
    LOG_OUT_USER
} from '../../actions/actionTypes';

const fetchMessagesReducer = (messages, payload) => {
    let newMessages = payload.offset == "" ? {} : { ...messages };
    if (payload.messages){
        for(let message of payload.messages){
            newMessages[message.messageId] = message;
        }
    } 
    return newMessages;
}

const messagesReducer = (state={}, action) => {
    let messages = state;
    if (action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_MESSAGES:
                return fetchMessagesReducer(messages, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return messages;
        }
    }
    return messages;
}

export default messagesReducer;